






























































































import { Component, Vue } from 'vue-property-decorator';
import User from '@/apiClient/User';
import _ from 'lodash';
import PasswordPolicie from "@/components/generics/PasswordPolicie.vue";

declare var mApp: any;

@Component({
    name: 'PassEdit',
    components: {
      PasswordPolicie
    },
    computed: {
      samePass() {
        return this.form.newpass === this.form.repeatpass
      }
    }
})

export default class PassEdit extends Vue {
    user: User;
    passwordPolicies: Object;
    loading: Boolean;
    isSuccessMessage: Boolean;
    messageSuccess: String;
    form: {
      currentpass: null,
      newpass: null,
      repeatpass: null,
      error: null
    }

    created(){
      this.user = new User;
      this.user.passwordPoliciesV2().then((response) => {
        this.passwordPolicies = response.data
      })
      .catch(error => {});
    }
    updated(){
      if(typeof mApp !== 'undefined') mApp.init({})
    }
    data(){
      return {
        user: User,
        passwordPolicies: {},
        loading: false,
        isSuccessMessage: false,
        messageSuccess: '',
        form: {
          currentpass: null,
          newpass: null,
          repeatpass: null,
          error: null
        }
      }
    }
    clear(){
      this.form = _.mapValues(this.form, _.constant(null));
      this.$validator.reset();
    }
    submit(event:any){
      this.loading = true;
      this.$validator.validate().then( result => {
        if ( result ) {
          this.user.changePass(this.form.currentpass, this.form.newpass, this.form.repeatpass, 0)
            .then( (response) => {
              this.loading = false;
              this.isSuccessMessage = true;
              this.messageSuccess = `${this.$t('message.header_top_bar_password_changed_message')}`;
              this.clear();
            }).catch( error => {
              this.loading = false;
              let response = error.response.data;
              this.form.error = response.results.data[0];
            });
        }
      });
    }
}
